import type { SymbolType } from '@visactor/vrender-core';

export type ShapeType = SymbolType;

export interface IShapeStyle {
  shape?: ShapeType;
  size?: number;
}
